import { render, staticRenderFns } from "./Game5-13.vue?vue&type=template&id=7501ee3f&scoped=true&"
import script from "./Game5-13.vue?vue&type=script&lang=js&"
export * from "./Game5-13.vue?vue&type=script&lang=js&"
import style0 from "./Game5-13.vue?vue&type=style&index=0&id=7501ee3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7501ee3f",
  null
  
)

export default component.exports